import { generateTitle } from 'utils/charts/common';
import {
    noResultsText,
    SCENARIO_ONE_TREND_Y_AXIS_AMOUNT,
    TREND_ANALYSIS_TITLE
} from 'utils/charts/constants';
import BlackCircle from 'assets/images/black-circle-icon.svg';
import OrangeCircle from 'assets/images/cream-orange-circle-icon.svg';

const portfolioLossesGraphic = {
    image: {
        type: 'image',
        style: {
            image: BlackCircle
        },
        cursor: 'default',
        bottom: '3.5%',
        width: 12,
        height: 12,
        top: '94.5%',
        left: '23.5%'
    },
    text: {
        type: 'text',
        style: {
            text: 'Portfolio Unrealized Losses',
            font: '10px "Outfit" 400',
            fill: '#929292'
        },
        cursor: 'default',
        bottom: 10,
        left: '26.5%'
    }
};

const rmRevenueGraphic = {
    image: {
        type: 'image',
        style: {
            image: OrangeCircle
        },
        cursor: 'default',
        bottom: 23,
        top: '94.5%',
        left: '56.5%'
    },
    text: {
        type: 'text',
        style: {
            text: 'RM Revenue',
            font: '10px "Outfit" 400',
            fill: '#929292'
        },
        cursor: 'default',
        bottom: 10,
        left: '59.5%'
    }
};
export const scenarioOneNoResultTrendAnalysisChartOptions = () => {
    return {
        title: generateTitle(TREND_ANALYSIS_TITLE),

        xAxis: [
            {
                axisTick: {
                    show: false
                },
                splitLine: {
                    show: false
                },
                axisLine: {
                    show: false
                },
                boundaryGap: false
            }
        ],
        yAxis: [
            {
                name: SCENARIO_ONE_TREND_Y_AXIS_AMOUNT,
                nameLocation: 'center',
                nameTextStyle: {
                    color: '#7FADBF',
                    fontWeight: 600,
                    fontSize: 12
                },
                nameGap: 30,
                axisLabel: {
                    show: false
                },
                axisLine: {
                    show: false
                },
                splitLine: {
                    show: false
                }
            }
        ],
        grid: {
            width: '440px',
            height: '280px',
            top: '10%'
        },
        graphic: [
            portfolioLossesGraphic.image,
            portfolioLossesGraphic.text,
            rmRevenueGraphic.image,
            rmRevenueGraphic.text,
            noResultsText
        ]
    };
};
